import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import { createUseStyles } from 'react-jss'
import {
  CustomerAddress,
  DocumentDate,
  Footer,
  Header,
  Payment,
  Subject,
  TableBody,
  TableHeader,
  theme
} from '../../document/Document'
import { baseDocument } from '../../../utils/constants/misc'

const useStyles = createUseStyles(theme)

const Order = ({ document_param: order, company_param: company, logo_param: logo, settings_param: settings }) => {
  const customer = order.customer
  const classes = useStyles()

  const References = () => {
    if (order) {
      return (
        <>
          <Box className={classes.rightContainer}>
            <Typography className={classes.boldWithSpace}>Référence commande</Typography>
            <Typography className={classes.address}>{order.order_number}</Typography>
          </Box>
          {order.quote_id !== null && (
            <Box className={classes.rightContainerNoMT}>
              <Typography className={classes.boldWithSpace}>Référence devis</Typography>
              <Typography className={classes.address}>{order.quote.quote_number}</Typography>
            </Box>
          )}
        </>
      )
    }
  }

  return (
    <Paper className={classes.paper}>
      <Box className={classes.page}>
        <Header logo={logo} classes={classes} documentTitle={'BON DE COMMANDE'} />
        <References />
        <DocumentDate date={order.order_date} classes={classes} />
        <CustomerAddress customer={customer} company={company} classes={classes} />
        <Subject document={order} classes={classes} />
        <TableHeader headers={baseDocument} classes={classes} />
        <TableBody headers={baseDocument} lines={order.lines} total={order.total_amount_net} classes={classes} />
        <Payment customer={customer} settings={settings} classes={classes} />
        <Footer company={company} classes={classes} />
      </Box>
    </Paper>
  )
}

export default Order
